// 안전한 숫자 변환 함수
export const safeNumber = (value: unknown, fallback: number = 0): number => {
  const num = Number(value)
  return isNaN(num) || !isFinite(num) ? fallback : num
}
